import { render, staticRenderFns } from "./ScholarshipLayout.vue?vue&type=template&id=03085d32&scoped=true&"
import script from "./ScholarshipLayout.vue?vue&type=script&lang=js&"
export * from "./ScholarshipLayout.vue?vue&type=script&lang=js&"
import style0 from "./ScholarshipLayout.vue?vue&type=style&index=0&id=03085d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03085d32",
  null
  
)

export default component.exports